import image1 from '@/assets/images/news/detail/20200717/1.jpeg';

export default {
  id: '20200717', //  模块 id
  title: '“叮咚买菜”怎么卖菜？大数据预测需求，数字化规划配送，卖菜也能高科技', // 标题
  origin: '2020-07-17 08:34 来源：新民晚报', // 新闻来源
  editor: '记者：张钰芸', // 编辑者
  content: [
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text: '图说：叮咚买菜 来源/叮咚官网截图',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '新民晚报讯（记者 张钰芸）不管是刮风下雨，还是烈日炎炎，手机下单后的29分钟里，叮咚买菜的小哥就会把生鲜产品送到你的家门口。最近几个月，城市居民的买菜方式发生了“颠覆性”变化，从天天迈进小菜场，到在手机上动动手指，以生鲜电商为代表的在线消费等新兴产业正展现出强大成长潜力，上海本土互联网企业“叮咚买菜”更是异军突起。“叮咚买菜”是怎么卖菜的？“技术”是其背后的奥秘。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '“从产地、运输、分选仓到前置仓，依托于叮咚买菜开发的供应链系统，每一棵小葱从产地到末端，我们都能从数字化系统搞明白，这棵葱从哪儿来的，又到哪儿去了。”叮咚买菜相关负责人告诉记者，只要用手机扫描产品包装的二维码，即可追溯货源，看到清晰的货运和上架时间。同时在产地端也提高了供应链的效率，使生鲜可以迅速地到达用户手里，进行了价值的重新分配，带动了农业的良性循环。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '此外，针对生鲜产品在销售环节损耗大的痛点，叮咚买菜则根据用户需求积累下大数据，帮助其逐步实现大数据预测，有针对性地根据仓储情况对用户做有效推荐，不仅能有效降低损耗，也能保证到达用户手中的生鲜产品在最佳食用期中。      ',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '让生鲜电商都在赛跑的配送能力上，叮咚买菜更是做到了全流程的数字化，包括系统后台对小哥配送线路的自动调度以及骑行路径规划。“比方说，在数字化的配送支持下，我们的小哥一个小时可以配送7单，解决7个家庭的吃饭问题，等于用1个小时代替了社会的7个小时运力。”',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '近期上海“暴力梅”再加上南方地区进入汛期，极端天气下的农副产品保供应、稳价格是民生大事。叮咚买菜表示，坚持产地直采，全国350个生鲜直供产地和超500家的产地直供供应商，为汛期前后菜品基本不涨价带来底气。“以夏日消耗较多的上海市民比较喜欢的黄瓜为例，平均每天的采购量在15吨左右，均由寿光基地冷链发出，目前供应平稳，未受到暴雨天气影响。”',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '发挥移动互联、物联网、智能算法、自动化等技术的优势，卖菜这件事的技术门槛提高了，市民的高品质生活也得到了保障。“坚持用户思维来解决大家的生鲜需求问题。”叮咚买菜表示，未来将在数字化、人工智能等技术上再下功夫，力争在需求预测、配送路线规划等方面有持续突破，“卖菜也可以是一个高科技的行业”。',
      isIndent: false,
    },
  ],
};
